"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredGuildCompetitionWithWinnersToJSON = exports.SponsoredGuildCompetitionWithWinnersFromJSONTyped = exports.SponsoredGuildCompetitionWithWinnersFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function SponsoredGuildCompetitionWithWinnersFromJSON(json) {
    return SponsoredGuildCompetitionWithWinnersFromJSONTyped(json, false);
}
exports.SponsoredGuildCompetitionWithWinnersFromJSON = SponsoredGuildCompetitionWithWinnersFromJSON;
function SponsoredGuildCompetitionWithWinnersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'promotionImage': json['promotionImage'],
        'rewards': (json['rewards'].map(_1.SponsoredRewardResponseFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'description': json['description'],
        'brandUrl': json['brandUrl'],
        'winnerSummaries': !(0, runtime_1.exists)(json, 'winnerSummaries') ? undefined : (json['winnerSummaries'].map(_1.WinnerSummaryFromJSON)),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.SponsoredGuildCompetitionWithWinnersFromJSONTyped = SponsoredGuildCompetitionWithWinnersFromJSONTyped;
function SponsoredGuildCompetitionWithWinnersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'sponsorBrandName': value.sponsorBrandName,
        'promotionImage': value.promotionImage,
        'rewards': (value.rewards.map(_1.SponsoredRewardResponseToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'description': value.description,
        'brandUrl': value.brandUrl,
        'winnerSummaries': value.winnerSummaries === undefined ? undefined : (value.winnerSummaries.map(_1.WinnerSummaryToJSON)),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.SponsoredGuildCompetitionWithWinnersToJSON = SponsoredGuildCompetitionWithWinnersToJSON;
